'use client';

import { usePathname } from '@/navigation';
import { useEffect } from 'react';
import { useModals } from './ModalContext';
import { useIsLogined } from './LoginContext';
import { BonusAppliedModal } from '@/modals/BonusAppliedModal';

const MODAL_KEY = 'bonus-applied-modal';

export const BonusCoinsContextProvider = ({ children }) => {
  const pathname = usePathname();
  const { open } = useModals();
  const isLogined = useIsLogined();

  useEffect(() => {
    const read = () => {
      const url = new URL(window.location.href);
      const amount = url.searchParams.get('bonusApplied');
      const shouldOpen = !!amount && Number(amount) > 0 && isLogined;

      if (shouldOpen) {
        open(
          MODAL_KEY,
          <BonusAppliedModal
            amount={amount as string}
            onOk={() => {
              const cleanUrl = new URL(window.location.href);
              cleanUrl.searchParams.delete('bonusApplied');
              window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
            }}
          />,
          true,
          'md:h-unset h-unset absolute md:static my-0 top-0 bottom-0 md:top-unset md:my-[30px]',
        );
      }
    };

    // initial
    read();

    // react to back/forward
    const onPopState = () => read();
    window.addEventListener('popstate', onPopState);

    return () => {
      window.removeEventListener('popstate', onPopState);
    };
    // re-run on pathname change (client navs) and once the user becomes known
  }, [pathname, open, isLogined]);

  return <>{children}</>;
};
